import React, { useEffect } from 'react';

function AdsBanner(props) {
  const { showStrip, firstLoad, colorPage } = props;

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.log(err);
    }
  }, []);
  const minHeight = props.firstLoad ? props.minHeight || '320px' : '';
  return (
    <div
      style={{
        width: colorPage ? 'max-content' : '100%',
        minHeight: minHeight,
        background: '#eee',
        margin: 'auto',
        // padding: "14px 0",
      }}
    >
      {showStrip && (
        <p style={adCoverStyle}>Article Continues below advertisement</p>
      )}
      <ins
        className="adsbygoogle adbanner-customize"
        style={
          colorPage
            ? props.style
            : {
                display: 'block',
                overflow: 'hidden',
                width: '100%',
              }
        }
        data-ad-client={'ca-pub-5148846221422351'}
        {...props}
      />
    </div>
  );
}

export default AdsBanner;
const adCoverStyle = {
  fontSize: '14px',
  textAlign: 'center',
  opacity: '0.8',
  letterSpacing: '0.1px',
  padding: '14px',
};
